export default __webpack_public_path__ + "static/logo-amazon-1bd3333eec7ba3f45f58fc9adeeecdeb.svg";